import { render, staticRenderFns } from "./giveMedici.vue?vue&type=template&id=7000d31e&scoped=true"
import script from "./giveMedici.vue?vue&type=script&lang=js"
export * from "./giveMedici.vue?vue&type=script&lang=js"
import style0 from "./giveMedici.vue?vue&type=style&index=0&id=7000d31e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7000d31e",
  null
  
)

export default component.exports